import { AffirmationWithCategory } from "../../interfaces/tell_me/affirmationWithCategory.types"
import { Category } from "../../interfaces/tell_me/category.types"
import { ReelWithCategory } from "../../interfaces/tell_me_watch/reel.types"
import { ReelsCategory } from "../../interfaces/tell_me_watch/reelsCategory.types"
import { actionTypes } from "./action_types"

export interface ActionInterface {
    type: string,
    payload: any,
}

const setCategoryAndAffirmation = (
    affirmations: AffirmationWithCategory[],
    categories: Category[],
): ActionInterface => {
    return {
        payload: {
            affirmations: affirmations,
            categories: categories,
        },
        type: actionTypes.SET_AFFIRMATION_AND_CATEGORIES
    }
}

const setReelsAndReelsCategories = (
    reels: ReelWithCategory[],
    reelsCategories: ReelsCategory[]
): ActionInterface => {
    return {
        payload: {
            reels: reels,
            reelsCategories: reelsCategories,
        },
        type: actionTypes.SET_REELS_AND_REELS_CATEGORIES
    }
}


export {
    setCategoryAndAffirmation,
    setReelsAndReelsCategories,
}